import React from 'react';
import autoBind from "auto-bind";
import ApiClient from "utils/ApiClient";
import Util from 'utils/Utils';
import ColumnValidatorFactory from "./Columns/validators/ColumnValidatorFactory";
import { clone } from 'lodash';
import { handleAddEditColumn } from "app/websocketManager/eventEmitter";

const { decorate, observable, action, computed } = require("mobx");


class AddColumnStore {
    addColumnButtonPosition = "";
    open = false;
    anchorEl = null;
    isLoading = false;
    allLists = [];
    isFormulaDataTypeOpen = false;

    constructor(appStore, list, listColumns, containerStore, isSubsheet = false) {
        this.appStore = appStore;
        this.list = list;
        this.listColumns = listColumns;
        this.containerStore = containerStore;
        this.isSubsheet = isSubsheet;

        window.addColumnStore = this; //TODO: remove this
        autoBind(this);
    }

    setColumns(columns) {
        this.listColumns = columns;
    }

    setOpen = (open) => {
        this.open = open;
        if (!open) {
            this.column = {};
            return;
        }
        this.fetchUserLists();
    };

    trimOptions = (column) => {
        if (column.options?.options && (column.column_type_id == 3 || column.column_type_id == 11 || column.column_type_id == 13)) {
            let options = JSON.parse(JSON.stringify(column.options.options));
            Object.keys(options).forEach((index) => (options[index] = (typeof options[index] == "string" ? options[index].trim() : options[index])));
            column.options.options = options;
        }
    };

    setData = async (id, operation, gridApi) => {
        let column;
        if (this.isSubsheet) {
          column = this.listColumns.find((col) => col.id == id);
        } else {
          column = this.getCurrentListColumns().find((col) => col.id == id);
        }
        column = { ...column, column_name: column.name, column_id: column.id };
        column.options = typeof column.options == "string" ? JSON.parse(column.options)[0] : column.options;
        if (column.options.formula_column?.options) {
          if (typeof column.options.formula_column?.options == "string") {
            column.options.formula_column.options = JSON.parse(column.options.formula_column.options)[0]
          }   
        }
        if (column.options && column.column_type_id == 22) {
            column.options.decimals = column.options.decimals ? parseInt(column.options.decimals) - 2 : 2
            column.options.max_value = column.options.max_value ? column.options.max_value * 100 : ""
            column.options.min_value = column.options.min_value ? column.options.min_value * 100 : ""
        }
        this.trimOptions(column);
        this.column = column;
        if (operation === "duplicate") {
            gridApi.ensureColumnVisible("+")
            setTimeout(() => {
                this.setAnchorEl(this.addColumnButtonPosition);
            }, 100)
            let duplicateColumnValues = JSON.parse(JSON.stringify(this.column));
            const requiredProperties = {
                column_type_id: parseInt(duplicateColumnValues.column_type_id),
                options: duplicateColumnValues.options,
                formula: duplicateColumnValues.formula ?? ""
            };
            this.column = requiredProperties;
        }
        if (this.column.column_type_id === "7") {
            this.isLoading = true;
            const formula = await this.getFormula(column.formula_id);
            this.column.formula = formula;
            this.isLoading = false;
        }
    };

    setAnchorEl = (el) => {
        this.anchorEl = el;
    }

    setIsFormulaDataTypeOpen = (val) => {
        this.isFormulaDataTypeOpen = val;
    }

    validateColumnName(colName, colId) {
        return this.getCurrentListColumns().findIndex(col => {
            if (col.id === colId) {
                return false;
            }
            return Util.toUpperCamelCase(col.name) === Util.toUpperCamelCase(colName) || Util.toUpperCamelCase(colName) === "Id"
        }) === -1;
    }

    getCommonColumnOptions = ({ column_type_id: columnTypeId, options }) => {
        columnTypeId = parseInt(columnTypeId);
        if (columnTypeId === 7 || columnTypeId === 19) {
            return [];
        }

        if (columnTypeId === 6) {
            return [
                { name: "Is Mandatory?", value: "is_mandatory", isLocal: true },
            ];
        }
        const commonOptions = [
            { name: "Is Mandatory?", value: "is_mandatory", isLocal: true, isShownByDefault: columnTypeId === 1 || columnTypeId === 14 || columnTypeId === 20 },
            { name: "Is Unique?", value: "is_unique", isShownByDefault: columnTypeId === 1 || columnTypeId === 14 || columnTypeId === 20 },
            { name: "Read only. Editable via triggers", value: "is_read_only", isShownByDefault: false },
        ];

        if(columnTypeId === 1 || columnTypeId === 8 ) {
            commonOptions.push(
                { name: "Trim White Spaces", value: "trim_white_spaces", isShownByDefault: false }
            )
        }

        if(columnTypeId === 1 || columnTypeId === 14 || columnTypeId === 8 || columnTypeId === 20 || columnTypeId === 5 || columnTypeId === 17 || columnTypeId === 22 || columnTypeId === 4 || columnTypeId === 16 ) {
            commonOptions.push(
                { name: "Highlight Duplicates", value: "is_highlighted", isShownByDefault: false }
            )
        }

        if (columnTypeId === 14) {
            commonOptions.splice(2, 0, {
                name: "Default as Logged-in-user's email", value: "default_email", isShownByDefault: false,
            })

            if (options.default_email) {
                commonOptions.splice(3, 0, {
                    name: "Allow user to change email", value: "allow_free_text", isShownByDefault: true,
                })
            }
        }
        if (
          columnTypeId === 3 ||
          columnTypeId === 13 ||
          columnTypeId === 11 ||
          columnTypeId === 9 ||
          columnTypeId === 12
        ) {
          commonOptions.splice(1, 1);
          if (columnTypeId === 12) {
            commonOptions.splice(0, 1);
          }
        }

        const mandatoryIndex = commonOptions.findIndex(option => option.value === "is_mandatory");
        if (columnTypeId === 3) {
        commonOptions.splice(mandatoryIndex + 1, 0, {
            name: "Allow Non-Admin Users to Add Options", value: "is_allow_non_admin", isShownByDefault: false
        });}
    
        return commonOptions;
    }

    getCurrentList() {
        return this.list
    }

    getCurrentListColumns() {
        return this.containerStore?.listConfig.listData ?? this.listColumns;
    }

    getCurrentListName() {
        return this.containerStore?.listConfig?.list?.name ?? this.appStore?.currentViewStore?.listConfig?.list?.name;
    }

    getCurrentListFormattedColumns() {
        let currentListColumns =
          this.containerStore == undefined
            ? JSON.parse(
                JSON.stringify(this.appStore?.currentViewStore?.listConfig?.listData)
              )
            : JSON.parse(JSON.stringify(this.getCurrentListColumns()));
        let currentListName = this.getCurrentListName();
        return TL.list.settings.lookup.CriteriaHelper.formatListColumns(currentListColumns, currentListName, "_CurrentRow");
    }

    get currentListId() {
        const { id: listId } = this.getCurrentList();
        return listId;
    }


    get codeSnippetColumnAliasNames() {
        const listColumns = this.getCurrentListColumns();
        const aliasNames = [];

        listColumns.forEach(col => {
            if (col.list_columns) {
                return col.list_columns.forEach(subsheetCol => aliasNames.push(<span>{col.alias_name}[<i>rownum</i>].{subsheetCol.alias_name}</span>));
            }
            aliasNames.push(col.alias_name)
        });

        return aliasNames;
    }

    get listIds() {
        return [this.getCurrentList().id, ...this.getCurrentListColumns().filter(col => col.column_type_id === "6").map(col => JSON.parse(col.options)[0].sub_list_id)];
    }

    getSelectableColumnsForExpressions() {
        const currentList = this.getCurrentList();
        var columns = [],
          list = {
            id: currentList.id,
            name: currentList.name,
            columns: this.isSubsheet
              ? this.listColumns
              : this.getCurrentListColumns(),
            has_parent: this.isSubsheet,
            parent_list: this.isSubsheet
              ? {
                  id: this.containerStore?.listConfig?.list.id ?? this.appStore.containerStore.listConfig.list.id,
                  name: this.containerStore?.listConfig?.list.name ?? this.appStore.containerStore.listConfig.list.name,
                  columns: this.containerStore?.listConfig?.listData ?? this.appStore.containerStore.listConfig.listData,
                }
              : {},
          };

        if (list && list.has_parent) {
            columns = TL.list.settings.lookup.CriteriaHelper.formatColumns(
                TL.list.settings.lookup.CriteriaHelper.addDefaultColumns(list.parent_list.id, Ext.clone(list.parent_list.columns)), {
                listNameStr: list.parent_list.name,
                doExpandSubSheetColumns: false
            }, false);
            columns = columns.concat(TL.list.settings.lookup.CriteriaHelper.formatCurrentSubSheetRowColumns(Ext.clone(list), {
                aliasKey: 'alias_name',
                listNameSuffix: '',
                parentListNameSuffix: ''
            }));
        } else {
            columns = TL.list.settings.lookup.CriteriaHelper.formatColumns(
                TL.list.settings.lookup.CriteriaHelper.addDefaultColumns(list.id, Ext.clone(list.columns)), {
                listNameStr: list.name,
                doExpandSubSheetColumns: true
            });
        }

        return {
            records: columns,
            selected_records: []
        };
    }


    async fetchUserLists(forceUpdate = false) {
        if (this.allLists.length > 0 && !forceUpdate) {
            return;
        }

        try {
            this.isListsFetching = true;
            const userLists = await ApiClient.Items.getUserLists();
            this.allLists = userLists.data;
        } catch (e) {

        }

        this.isListsFetching = false;
    }

    //todo: use global store for listconfig
    async fetchListColumns(listId) {
        try {
            let resp = await ApiClient.List.getListConfig({
                list_id: listId,
            });

            return resp.data;
            // this.containers[this.listId].listConfig = this.listConfig;
        } catch (e) {
            console.log(e);
        }

        return;
    }

    async validateExpressionFormula(formula) {
        if (!formula) {
            Ext.Msg.alert("Error", "formula is empty");
            return false;
        }
        try {
            await ApiClient.List.validateFilterQuery(this.listIds.join(","), formula);
            Ext.Msg.alert("Success", "Valid Formula");
        } catch (e) {
            Ext.Msg.alert("Error", e.response?.messages.join?.("<br />") ?? e.response?.messages ?? "Invalid Expression");

            // console.error(e);
            return false;
        }
    }

    async validateCodeSnippet(formula) {
        if (!formula) {
            Ext.Msg.alert("Error", "code is empty");
            return false;
        }
        try {
            await ApiClient.List.testCodeSnippetSyntax(this.getCurrentList().name, this.getCurrentListColumns(), formula);

            Ext.Msg.alert("Success", "Valid Formula");
        } catch (e) {
            Ext.Msg.alert("Error", "Invalid Formula");
            // console.error(e);
            return false;
        }
    }

    async getFormula(formulaId) {
        const { id: listId } = this.getCurrentList();
        if (!formulaId) {
            return "";
        }

        try {
            let response = await ApiClient.List.getFormula(listId, formulaId);
            return response?.formula ?? "";
        } catch (e) {
            console.error(e);
            return "";
        }
    }

    async createList(listName) {
        const { id: listId } = this.getCurrentList();

        try {
            // const { data: { list_cols: listColumns } } = await ApiClient.List.getListTemplate("", 1);
            // listColumns.forEach(col => {
            //     col.column_name = col.name;
            //     delete col.col_width;
            // });

            const response = await ApiClient.List.createList(listId, listName, []);

            return response.data.list_id;
        } catch (e) {
            Ext.Msg.alert("Error", e.response?.messages ?? "Something went wrong. Please try again");
            console.error(e);

            return false;
        }
    }

    async saveColumn(columnConfig, updateGrid = true) {
        var dec = columnConfig.options.decimals
        if (columnConfig.column_type_id == 22) {
            if (columnConfig.options.hasOwnProperty("max_value") && columnConfig.options.max_value != "" && columnConfig.options.max_value != null) {
                columnConfig.options.max_value = parseInt(columnConfig.options.max_value) / 100
            } else {
                columnConfig.options["max_value"] = null
            }
            if (columnConfig.options.hasOwnProperty("min_value") && columnConfig.options.min_value != "" && columnConfig.options.min_value != null) {
                columnConfig.options.min_value = parseInt(columnConfig.options.min_value) / 100
            } else {
                columnConfig.options["min_value"] = null
            }
            if (columnConfig.options.hasOwnProperty("decimals")) {
                columnConfig.options["decimals"] = dec + 2
            } else {
                columnConfig.options["decimals"] = "4"
            }
        }
        if(!columnConfig.options.hasOwnProperty("decimals") && (columnConfig.column_type_id == 5 || columnConfig.column_type_id == 17)){
            columnConfig.options["decimals"] = "2";
        }

        if (
            columnConfig?.column_type_id == 10 &&
            (columnConfig?.options?.column_type == "date" ||
              columnConfig?.options?.column_type == "datetime")
          ) {
            let sourceColumnConfig = await ApiClient.List.getColumnConfigs({
              list_id: columnConfig?.options?.source_list_id,
              column_id: columnConfig?.options?.source_column_id,
            });
            let options =
              typeof sourceColumnConfig?.data?.options == "string"
                ? JSON.parse(sourceColumnConfig?.data?.options)[0]
                : sourceColumnConfig?.data?.options;
            columnConfig.options["format"] = options?.format;
          }
        // console.log(columnConfig)
        columnConfig = clone(columnConfig);

        if (columnConfig?.column_type_id == "7" && columnConfig.column_id != 0 && columnConfig.column_name && columnConfig.name && columnConfig.column_name != columnConfig.name) {
            const codesnippetFormula = columnConfig.formula;

            const pattern = new RegExp(`(?<![a-zA-Z0-9])${columnConfig.alias_name}(?![a-zA-Z0-9])`, 'g');
            const newColumnName = Util.toCamelCase(columnConfig.column_name);

            const newCodesnippetFormula = codesnippetFormula.replace(pattern, newColumnName);
            columnConfig.formula = newCodesnippetFormula;  
        }

        this.trimOptions(columnConfig);
        
        if (columnConfig.options.formula_column?.options) {
            columnConfig.options.formula_column.options = JSON.stringify([columnConfig.options.formula_column.options]);
        }

        if (columnConfig.column_type_id === "10-1") {
            columnConfig.column_type_id = "10";
            columnConfig.is_user_type = true;
        }

        if (!ColumnValidatorFactory(columnConfig.column_type_id)(columnConfig)) {
            return false;
        }

        if (parseInt(columnConfig.column_type_id) === 6 && !columnConfig.options.sub_list_id) {
            const subListId = await this.createList(columnConfig.column_name);
            if (!subListId) {
                return false;
            }

            columnConfig.options.sub_list_id = subListId;
        }

        columnConfig.options = JSON.stringify([columnConfig.options]);
        delete columnConfig.event_handlers;

        const { id, name, add_button_text = "new" } = this.getCurrentList();
        try {
            const resp = await ApiClient.List.addEditColumn({
                list_id: id,
                list_name: name,
                add_button_text: add_button_text,
                data: [columnConfig],
                enable_striked_column: 1,
                is_web: 1,
                parent_id: this.isSubsheet ? this.appStore?.containerStore?.listId : ""
            });

            // this.containerStore.setListColumns(resp.data.listColumns);
            const column = resp.data.list_columns.find(x => x.id == resp.data.column_id);

            if (updateGrid) {
                const isOldColumn = columnConfig.column_id > 0 ? true : false;
                const prevHighlightState = this?.column?.options?.is_highlighted ?? false;
                if (columnConfig.column_type_id === "3") {
                    await this.containerStore?.currentViewStore?.refreshData?.();
                }
                if (!this.onColumnConfigChange) {
                    this.containerStore.addColumn(column);
                    let shouldRefreshData = false;
                    let shouldRedrawRefreshedRows = false;
                    try {
                        const columnOptions = JSON.parse(column.options);
                        if (columnOptions[0].is_highlighted) {
                            if (isOldColumn && (!prevHighlightState || (prevHighlightState && (column.column_type_id == "22" || column.column_type_id == "5" || column.column_type_id == "17")))) {
                                await this.containerStore?.currentViewStore?.getDuplicateColumnsData?.({["column_" + column.id] : column.column_type_id});
                            } else if (!isOldColumn && this.containerStore?.currentViewStore?.duplicateColumnsData) {
                                this.containerStore.currentViewStore.duplicateColumnsData["column_" + column.id] = {};
                                const duplicateColumn = {
                                    ...column,
                                    options: (() => {
                                        const parsedOpts = JSON.parse(column.options);
                                        return Array.isArray(parsedOpts) ? (parsedOpts[0] ?? {}) : parsedOpts;
                                    })()
                                };
                                this.containerStore.currentViewStore.duplicateColumnsConfigs["column_" + column.id] = duplicateColumn;
                            }
                            if (Object.keys(this.containerStore?.currentViewStore?.duplicateColumnsData).length > 1) {
                                if ((column.column_type_id === "22" || column.column_type_id === "5" || column.column_type_id === "17") && (this?.column?.options?.decimals || this?.column?.options?.decimals == 0) && columnOptions[0].decimals !== this?.column?.options?.decimals && columnOptions[0].decimals + this?.column?.options?.decimals > 0 && !this.containerStore?.currentViewStore?.isLazyLoadEnabled) {
                                    this.containerStore?.currentViewStore?.refreshData();
                                    shouldRefreshData = true;
                                }
                                this.containerStore?.currentViewStore?.redrawRefreshedRows();
                                shouldRedrawRefreshedRows = true;
                            }
                        }
                        else if (!columnOptions[0].is_highlighted && this.containerStore?.currentViewStore.duplicateColumnsData["column_" + column.id]) {
                            delete this.containerStore?.currentViewStore.duplicateColumnsData["column_" + column.id];
                        }   
                    } catch (e) {
                        console.log("Error", e);
                    }
                    handleAddEditColumn(JSON.stringify({...column, prevHighlightState}), 0, this.list.id ?? this.containerStore.listId, false, isOldColumn, shouldRefreshData, shouldRedrawRefreshedRows);
                } else {
                    await this.onColumnConfigChange({...column, prevHighlightState}, this?.column?.options?.decimals);
                    handleAddEditColumn(JSON.stringify({...column, prevHighlightState}), this?.column?.options?.decimals, this.list.id ?? this?.currentListId, true, isOldColumn, false, false, this.isSubsheet ? this.appStore?.containerStore?.listId : "");
                }
            }

            return column;
        } catch (e) {
            if (e.response.duplicates) {
              try {
                await window.appStore.notificationStore.confirm({
                  description: <>{e.response.msg}</>,
                });
                return true;
              } catch (e) {
                console.log(e);
                return false;
              }
            } else {
              Ext.Msg.alert(
                "Error",
                e.response?.msg || "Something went wrong. please try again.."
              );
            }
            console.log(e);
        }
        return false;
    }
}

decorate(AddColumnStore, {
    open: observable,
    anchorEl: observable,
    isLoading: observable,
    allLists: observable,
    listColumns: observable,
    isFormulaDataTypeOpen: observable,

    codeSnippetColumnAliasNames: computed,
});

export default AddColumnStore;
